var divider_viewer_default = {
  "divider-container": "Z31Z3",
  "divider-container--double": "zbP1Q",
  "divider": "dKpDO",
  "divider--single": "kAEs2",
  "divider--double": "uL5De",
  "divider--dashed": "GWd9M",
  "divider--dotted": "IMYPn",
  "divider--small": "_2JFJ-",
  "divider--medium": "T-IFy",
  "divider--large": "-yQBa",
  "divider--left": "Tbo1I",
  "divider--center": "YyUYJ",
  "divider--right": "oW8Os",
  "svgFixerContainer": "XBGC3",
  "emptyChar": "Plq-L"
};
export {
  divider_viewer_default as default
};
//# sourceMappingURL=divider-viewer-scss.js.map
